module.exports = __webpack_public_path__ + "img/tutoriais_mascara.58560eca.png";